function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const colors = {
  error: "var(--error)",
  warning: "var(--warning)",
  information: "var(--info)",
  info: "var(--info)",
  success: "var(--success)",
  text: "var(--icon-secondary)",
  disabled: "var(--icon-primary-disabled)",
  "on-color": "var(--icon-on-color)"
};
const resolveParams = (color, size, style) => {
  const colorResolved = colors[color];
  let result = {
    ...style
  };
  if (colorResolved) {
    result["--icon-primary"] = colorResolved;
  }
  if (size) {
    result.height = size;
    result.width = size;
  }
  return result;
};
export const ApiNavIconsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "29px",
  height: "17px",
  viewBox: "0 0 29 17",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-61.000000, -709.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(61.000000, 623.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.79999995,-1.28341782e-12 L24.7,-1.28341782e-12 C26.7986821,-1.28380334e-12 28.5,1.70131793 28.5,3.79999995 L28.5,12.3499998 C28.5,14.4486819 26.7986821,16.1499998 24.7,16.1499998 L3.79999995,16.1499998 C1.70131793,16.1499998 2.57014422e-16,14.4486819 0,12.3499998 L0,3.79999995 C-1.14519284e-15,1.70131793 1.70131793,-1.28303229e-12 3.79999995,-1.28341782e-12 Z M11.0218999,12 L12.7242998,12 L9.23969988,3.12890011 L7.29789991,3.12890011 L3.81329995,12 L5.51569993,12 L6.16739992,10.2976 L10.3701999,10.2976 L11.0218999,12 Z M8.2687999,4.44560009 L9.93129988,8.92770004 L6.60629992,8.92770004 L8.2687999,4.44560009 Z M13.6951998,12 L15.2512998,12 L15.2512998,8.68830004 L17.5920998,8.68830004 C19.4407998,8.68830004 20.4914997,7.41150006 20.4914997,5.90860008 C20.4914997,4.4057001 19.4540998,3.12890011 17.5920998,3.12890011 L13.6951998,3.12890011 L13.6951998,12 Z M18.8954998,5.90860008 C18.8954998,6.75980007 18.2570998,7.31840006 17.3792998,7.31840006 L15.2512998,7.31840006 L15.2512998,4.49880009 L17.3792998,4.49880009 C18.2570998,4.49880009 18.8954998,5.05740009 18.8954998,5.90860008 Z M21.7815997,12 L23.3376997,12 L23.3376997,3.12890011 L21.7815997,3.12890011 L21.7815997,12 Z",
  id: "Combined-Shape"
}))))));
export const ComputingIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Computing",
  width: "28px",
  height: "28px",
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Computing"
}, " Computing"), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-62.000000, -1003.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(62.000000, 1003.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M26.3666667,0.145833333 L1.63333333,0.145833333 C0.875,0.145833333 0.2625,0.758333333 0.2625,1.54583333 L0.2625,20.65 C0.2625,21.4083333 0.875,22.05 1.6625,22.05 L11.2583333,22.05 L11.2583333,22.8666667 C11.2583333,23.9166667 10.675,24.8791667 9.7125,25.375 L7.99166667,26.25 C7.90416667,26.3083333 7.7875,26.3666667 7.7,26.425 C7.02916667,26.8625 7.35,27.9125 8.1375,27.9125 L19.8625,27.9125 C20.6791667,27.9125 20.9708333,26.8625 20.3291667,26.425 C20.2416667,26.3666667 20.125,26.3083333 20.0375,26.25 L18.3166667,25.375 C17.3833333,24.9083333 16.7708333,23.9458333 16.7708333,22.8666667 L16.7708333,22.05 L26.3666667,22.05 C27.125,22.05 27.7666667,21.4375 27.7666667,20.65 L27.7666667,1.54583333 C27.7375,0.758333333 27.125,0.145833333 26.3666667,0.145833333 Z M14,20.5333333 C13.475,20.5333333 13.0375,20.0958333 13.0375,19.5708333 C13.0375,19.0458333 13.475,18.6083333 14,18.6083333 C14.525,18.6083333 14.9625,19.0458333 14.9625,19.5708333 C14.9625,20.0958333 14.525,20.5333333 14,20.5333333 Z M24.9375,17.15 L3.0625,17.15 L3.0625,2.94583333 L24.9375,2.94583333 L24.9375,17.15 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9291667,13.3 C12.1916667,13.5625 12.5416667,13.7083333 12.9208333,13.7083333 C13.2708333,13.7083333 13.6208333,13.5625 13.9125,13.3 L18.4625,8.75 C19.0166667,8.19583333 19.0166667,7.32083333 18.4625,6.79583333 C17.9083333,6.24166667 17.0333333,6.24166667 16.5083333,6.79583333 L12.9208333,10.3833333 L11.4916667,8.95416667 C10.9375,8.4 10.0625,8.4 9.5375,8.95416667 C8.98333333,9.50833333 8.98333333,10.3833333 9.5375,10.9083333 L11.9291667,13.3 Z",
  id: "Path"
}))))));
export const ContactIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Contact",
  width: "26px",
  height: "23px",
  viewBox: "0 0 26 23",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Contact"
}, " Contact"), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-62.000000, -988.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(41.000000, 902.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(21.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13,0 C5.832125,0 0,4.77658286 0,10.6473898 C0,13.6466776 1.5145,16.4592266 4.1795,18.4707642 C3.38,19.6583577 2.19375,20.924578 0.6175,21.3193505 C0.2405,21.414358 -0.017875,21.7632647 0.001625,22.1547611 C0.021125,22.5462574 0.310375,22.8689552 0.6955,22.9246492 C0.754,22.9328395 1.236625,23 2.029625,23 C3.679,23 6.667375,22.7084253 9.949875,20.9950146 C10.92325,21.1932199 11.947,21.2947796 13,21.2947796 C20.167875,21.2947796 26,16.5181967 26,10.6473898 C26,4.77658286 20.167875,0 13,0 Z M6.5,13.1044797 C5.603,13.1044797 4.875,12.3706289 4.875,11.4664198 C4.875,10.5622107 5.603,9.8283598 6.5,9.8283598 C7.397,9.8283598 8.125,10.5622107 8.125,11.4664198 C8.125,12.3706289 7.397,13.1044797 6.5,13.1044797 Z M13,13.1044797 C12.103,13.1044797 11.375,12.3706289 11.375,11.4664198 C11.375,10.5622107 12.103,9.8283598 13,9.8283598 C13.897,9.8283598 14.625,10.5622107 14.625,11.4664198 C14.625,12.3706289 13.897,13.1044797 13,13.1044797 Z M19.5,13.1044797 C18.603,13.1044797 17.875,12.3706289 17.875,11.4664198 C17.875,10.5622107 18.603,9.8283598 19.5,9.8283598 C20.397,9.8283598 21.125,10.5622107 21.125,11.4664198 C21.125,12.3706289 20.397,13.1044797 19.5,13.1044797 Z",
  id: "Shape"
})))))));
export const FabricViewIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Fabric-view",
  width: "22px",
  height: "17px",
  viewBox: "0 0 22 17",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Fabric-view"
}, " Fabric view"), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-64.000000, -172.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(39.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.7,12.2966667 L39.025,12.2966667 L39.025,17 L32.7,17 L32.7,12.2966667 Z M25,6.205 L31.325,6.205 L31.325,10.9083333 L25,10.9083333 L25,6.205 Z M25,-4.05719902e-12 L47,-4.05719902e-12 L47,4.78833333 L25,4.78833333 L25,-4.05719902e-12 Z M40.4,12.2966667 L47,12.2966667 L47,17 L40.4,17 L40.4,12.2966667 Z M25,12.2966667 L31.325,12.2966667 L31.325,17 L25,17 L25,12.2966667 Z M32.7,6.205 L39.025,6.205 L39.025,10.9083333 L32.7,10.9083333 L32.7,6.205 Z M40.4,6.205 L47,6.205 L47,10.9083333 L40.4,10.9083333 L40.4,6.205 Z"
}))))));
export const InternalIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Internal",
  width: "24px",
  height: "23px",
  viewBox: "0 0 24 23",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Internal"
}, " Internal"), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-63.000000, -616.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50.000000, 530.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.500000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,10.5042067 L0,4.37227723 C-0.000485008018,3.85083839 0.328730329,3.39102159 0.809461215,3.24170064 L10.873571,0.0991263832 C11.0808891,0.0338770578 11.2962735,0.000481699724 11.5128895,0 C11.7250588,0.000904500279 11.9360101,0.0333833198 12.1393185,0.0964472918 L22.1931167,3.24170064 C22.6728264,3.39199347 23.000826,3.85157592 23,4.37227723 L23,18.6250437 C23.000826,19.145745 22.6728264,19.6053274 22.1931167,19.7556203 L12.1393185,22.9008736 C11.9320003,22.9661229 11.716616,22.9995183 11.5,23 C11.283384,22.9995183 11.0679997,22.9661229 10.8606815,22.9008736 L0.806883318,19.7556203 C0.327173626,19.6053274 -0.00082599618,19.145745 0,18.6250437 L0,12.6393217 L6.27488092,12.6391901 L4.77737477,14.0550998 C4.49988353,14.3174754 4.38344055,14.7079544 4.47190879,15.0794472 C4.56037702,15.4509399 4.84031604,15.7470078 5.20627552,15.8561249 C5.57223499,15.9652421 5.96861698,15.8708309 6.24610821,15.6084553 L9.69445236,12.3474807 C9.90419229,12.1491702 10.0247811,11.8744426 10.028772,11.5858277 C10.0327628,11.2972128 9.91981624,11.0192657 9.71563961,10.815249 L9.70052916,10.8001385 L6.25232172,7.53930858 C5.82337445,7.13372904 5.14684221,7.15268612 4.74124468,7.5816504 C4.33564715,8.01061468 4.35457586,8.68714612 4.78352313,9.09272566 L6.2809699,10.5085726 L0,10.5042067 Z M12.6471642,2.71659872 L12.6471642,20.2807222 L20.7546502,17.7463017 L20.7546502,5.25101922 L12.6471642,2.71659872 Z",
  id: "Combined-Shape"
})))))));
export const MoneyIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Money",
  width: "28px",
  height: "28px",
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Money"
}, " Money"), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-61.000000, -902.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(61.000000, 902.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14,-7.27595761e-12 C6.26783123,-7.27595761e-12 3.63797881e-12,6.26812324 3.63797881e-12,14.0001881 C3.63797881e-12,21.732253 6.26783123,28 14,28 C21.7321688,28 28,21.732253 28,14.0001881 C28,6.26812324 21.7321688,-7.27595761e-12 14,-7.27595761e-12 Z M15.0870109,21.4954661 L15.0870109,23.8518519 L12.7206883,23.8518519 L12.7206883,21.6556197 C11.1030773,21.6097015 9.53314737,21.1751589 8.61538462,20.6950715 L9.3400586,18.0183785 C10.3543657,18.5443842 11.7784939,19.0248449 13.3484239,19.0248449 C14.724871,19.0248449 15.6907089,18.4988393 15.6907089,17.6066083 C15.6907089,16.7371498 14.8939222,16.1879984 13.1068659,15.6164479 C10.5230229,14.7929075 8.76039822,13.6486866 8.76039822,11.4296821 C8.76039822,9.39397683 10.2574273,7.81521332 12.8412703,7.35789828 L12.8412703,5.18518519 L15.2075929,5.18518519 L15.2075929,7.198118 C16.8252039,7.24403616 17.9120179,7.58711577 18.7328422,7.95296781 L18.0085623,10.5378244 C17.4048643,10.2638087 16.2699752,9.73705644 14.5313881,9.73705644 C12.9622463,9.73705644 12.4543046,10.4004432 12.4543046,11.0410576 C12.4543046,11.773135 13.2999546,12.2767415 15.3522125,12.9856732 C18.2501203,13.9462214 19.3846154,15.2043044 19.3846154,17.2863011 C19.3850094,19.3223797 17.8875862,21.0381511 15.0870109,21.4954661 Z",
  id: "Shape"
})))));
export const NewsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-News",
  width: "29px",
  height: "24px",
  viewBox: "0 0 29 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-News"
}, " News"), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-65.000000, -251.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(21.000000, 165.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(44.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.2612216,8.04936411 C15.5591705,8.04936411 15.3569828,9.83815356 15.3569828,12.0444654 C15.3569828,14.251154 15.5587839,16.0395667 16.2612216,16.0395667 C16.9636594,16.0395667 17.165847,14.251154 17.165847,12.0444654 C17.1654604,9.83815356 16.9636594,8.04936411 16.2612216,8.04936411 Z M15.4343012,0 C14.868717,0 14.3228491,0.176354216 13.8067487,0.500047103 C12.5885971,1.06076307 9.2066898,4.40169571 8.44703641,5.10108337 C7.76392825,5.73038154 7.20530273,5.72171455 7.20530273,5.72171455 L2.48424055,5.72171455 C1.11222534,5.72171455 0,8.53245407 0,11.9996232 C0,15.4667923 1.11222534,18.2779086 2.48424055,18.2779086 L7.20452954,18.2779086 C7.20452954,18.2779086 7.76354166,18.2696185 8.44626323,18.8985398 C8.99058484,19.3993406 11.1964791,21.4104569 12.8909121,22.7365049 C13.3822706,23.253886 13.9138347,23.6254357 14.4732334,23.8259067 C14.6205249,23.8990108 14.7392087,23.9400848 14.8211662,23.9400848 C14.8238724,23.9400848 14.8238724,23.9321715 14.8254187,23.9306642 C15.0252868,23.9755064 15.2282477,24 15.433528,24 C18.5796142,24 21.1295756,18.6276024 21.1295756,12 C21.1303486,5.37239755 18.5803874,0 15.4343012,0 Z M17.0421376,19.9351861 C15.6469269,19.9351861 14.5157585,16.3824776 14.5157585,11.9996232 C14.5157585,7.61714555 15.6469269,4.06406029 17.0421376,4.06406029 C18.4373483,4.06406029 19.5685167,7.61676872 19.5685167,11.9996232 C19.5685167,16.3824776 18.4373483,19.9351861 17.0421376,19.9351861 Z M27.4801231,5.18549223 C27.8234168,4.81959491 26.3419961,3.689496 26.0477995,3.56212906 C25.753603,3.4343853 22.0724734,6.17842675 22.5274923,6.93320772 C22.9821245,7.68685822 27.1364427,5.55138954 27.4801231,5.18549223 Z M27.4801231,18.4654014 C27.8234168,18.8312987 26.3419961,19.9613976 26.0477995,20.0887645 C25.753603,20.2165083 22.0724734,17.4724668 22.5274923,16.7176859 C22.9821245,15.9640354 27.1364427,18.0995041 27.4801231,18.4654014 Z M27.9921863,9.84489698 C28.4903588,9.90452562 28.0819383,11.7224705 27.9384405,12.0091452 C27.795185,12.2961084 23.2114403,12.5602352 23.0748411,11.689559 C22.9386724,10.8199972 27.4937176,9.78551684 27.9921863,9.84489698 Z",
  id: "ic_news"
})))))));
export const ProductsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Products",
  width: "30px",
  height: "21px",
  viewBox: "0 0 30 21",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Products"
}, " Products"), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-60.000000, -433.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(41.000000, 347.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(19.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15,0 L5.45454545,1.88476454 L15,4.06038781 L24.5454545,1.88476454 L15,0 Z M3.40316206,2.55955679 L0,6.95734072 L10.5889328,10.3080332 L14.2766798,5.04930748 L3.48616601,2.58282548 C3.46195507,2.57661216 3.43818808,2.56883906 3.41501976,2.55955679 L3.40316206,2.55955679 Z M26.5968379,2.55955679 C26.5698064,2.56935203 26.5420595,2.57713038 26.513834,2.58282548 L15.7233202,5.04930748 L19.4110672,10.3080332 L30,6.95734072 L26.5968379,2.55955679 Z M14.43083,6.81772853 L11.3003953,11.2853186 C11.1551413,11.490295 10.888883,11.5757927 10.6482213,11.4947368 L3.80632411,9.33074792 L3.80632411,17.6376731 L14.43083,21 L14.43083,6.81772853 Z M15.56917,6.81772853 L15.56917,21 L26.1936759,17.6376731 L26.1936759,9.33074792 L19.3517787,11.4947368 C19.111117,11.5757927 18.8448587,11.490295 18.6996047,11.2853186 L15.56917,6.81772853 Z"
})))))));
export const StatusIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Status",
  width: "26px",
  height: "21px",
  viewBox: "0 0 26 21",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Status"
}, " Status"), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-63.000000, -894.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(28.000000, 808.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35,10.5240884 L41.1377379,10.5240884 C41.5910134,10.5240884 41.9985868,10.2381777 42.1739032,9.79946616 L42.7994984,8.23128903 L44.9849606,14.4984841 C45.1437943,14.9545236 45.5528661,15.2617004 46.0151322,15.2727273 L46.0398563,15.2727273 C46.4923826,15.2727273 46.9022035,14.9868165 47.0767708,14.5465297 L49.4293081,8.62195495 L50.0009597,9.85853863 C50.1890128,10.2657448 50.5816019,10.5240884 51.0116517,10.5240884 L53.3761764,10.5240884 C53.9972763,10.5240884 54.5,9.99479912 54.5,9.34263907 C54.5,8.69047902 53.9972763,8.1611897 53.3761764,8.1611897 L51.7151652,8.1611897 L50.3620817,5.2343458 C50.168784,4.81690035 49.7627091,4.53886593 49.3191734,4.56958362 C48.8778854,4.58297338 48.4845471,4.86652123 48.3144751,5.29499353 L46.1080349,10.853319 L43.9248203,4.59242497 C43.7659866,4.13638552 43.3576641,3.82999631 42.895398,3.81818182 C42.4391256,3.82605815 42.0120726,4.0954286 41.8337593,4.5428041 L40.3900206,8.1611897 L35,8.1611897 L35,2.81999999 C35,1.262557 36.262557,7.30186846e-16 37.82,0 L58.18,0 C59.737443,1.57991574e-16 61,1.262557 61,2.81999999 L61,18.18 C61,19.737443 59.737443,21 58.18,21 L37.82,21 C36.262557,21 35,19.737443 35,18.18 L35,10.5240884 Z",
  id: "ic_status"
}))))));
export const TimelineIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Timeline",
  width: "25px",
  height: "31px",
  viewBox: "0 0 25 31",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Timeline"
}, " Timeline"), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-63.000000, -423.000000)",
  fillRule: "nonzero",
  strokeWidth: 1.92
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(48.000000, 341.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(16.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "primary-stroke",
  points: "12.5624432 22.8261932 6.99539773 4.75132955 5.00485227 14.4743182 0.0441704545 14.4892159 0.0415568182 13.3436591 4.068125 13.331375 6.77167045 0.129375 12.5028523 18.7382045 15.9235795 6.371 18.7005682 13.3737159 22.9195 13.3436591 22.9273409 14.4892159 17.9251023 14.5263295 16.1175114 9.96945455"
})))))));
export const ToolsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Tools",
  width: "22px",
  height: "22px",
  viewBox: "0 0 22 22",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Tools"
}, " Tools"), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-64.000000, -524.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(52.000000, 438.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.8629118,11.0674719 L14.8897941,9.94723665 C16.6635,10.5073543 18.7172647,10.1339425 20.1175588,8.73364842 C21.5178529,7.3333543 22.1713235,5.46629548 21.4245,3.59923665 L17.8770882,7.14664842 L14.7030882,3.87929548 L18.2505,0.331883713 C16.2900882,-0.414939817 14.4230294,0.14517783 12.9293824,1.54547195 C11.5290882,2.94576607 11.1556765,4.90617783 11.6224412,6.67988371 L9.84873529,8.45358959 L6.58138235,5.18623665 L5.92791176,3.22582489 L2.00708824,0.611942536 L0.0466764706,2.5723543 L2.66055882,6.58653077 L4.62097059,7.24000136 L7.88832353,10.5073543 L0.700147059,17.6955308 C-0.233382353,18.6290602 -0.233382353,20.1227072 0.700147059,21.0562367 C1.63367647,21.9897661 3.12732353,21.9897661 3.9675,21.0562367 L10.5022059,14.5215308 L16.4767941,20.5894719 L19.7441471,17.322119 L13.8629118,11.0674719 Z M17.2236176,21.0562367 C18.1571471,21.9897661 19.6507941,21.9897661 20.4909706,21.0562367 C21.4245,20.1227072 21.4245,18.6290602 20.4909706,17.7888837 L17.2236176,21.0562367 Z",
  id: "Shape"
})))))));
export const UseCasesIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Use-cases",
  width: "23px",
  height: "17px",
  viewBox: "0 0 23 17",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Use-cases"
}, " Use cases"), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-64.000000, -346.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(44.000000, 260.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.3980047,0.499126853 C32.8683445,0.184029982 32.2532982,0 31.5945584,0 C29.6340151,0 28.0390307,1.60297153 28.0390307,3.57333261 C28.0390307,4.22967269 28.2191419,4.84344117 28.5276656,5.37273687 L25.358974,10.3524616 C24.8293137,10.0373648 24.2142675,9.85333478 23.5555276,9.85333478 C21.5949843,9.85333478 20,11.4563063 20,13.4266674 C20,15.3970285 21.5949843,17 23.5555276,17 C25.5160709,17 27.1110553,15.3970285 27.1110553,13.4266674 C27.1110553,12.4820472 26.7418274,11.6245815 26.1444587,10.9850018 L29.1540522,6.16517199 C29.7914456,6.77190107 30.6493083,7.14666522 31.5945584,7.14666522 C32.4917787,7.14666522 33.3099503,6.8084389 33.9360034,6.25534332 L36.8555413,10.9846666 C36.2578391,11.6242462 35.8889447,12.4820472 35.8889447,13.4263322 C35.8889447,15.3966933 37.4839291,16.9996648 39.4444724,16.9996648 C41.4050157,16.9996648 43,15.3966933 43,13.4263322 C43,11.4559711 41.4050157,9.85299957 39.4444724,9.85299957 C38.7857325,9.85299957 38.1706863,10.0370296 37.641026,10.3521264 L34.5897402,5.49039539 C34.9426246,4.93562377 35.150086,4.27894848 35.150086,3.5729974 C35.150086,2.6283772 34.7808581,1.77091146 34.1834894,1.13133185 L33.3980047,0.499126853 Z",
  id: "ic_use_cases"
}))))));